<template>
<div>

  <div class="flex flex-wrap">
    <v-button icon="arrow-left" @click="goToPage('edit-project')">{{ $t('project') }}</v-button>
  </div>

  <div class="mt-4">
    <b-tabs type="is-boxed" v-model="mainActiveTab">
      <b-tab-item>
        <template slot="header">
          <span> Paneles de actividad </span>
        </template>
        <div class="panel">
          <div v-if="isLoading" class="my-4 text-center">
            <scale-loader />
          </div>
          <div v-else >
              <div class="mb-3">
                <b-switch v-model="ignore_delayed_state"
                  :rounded="true"
                  :outlined="false"
                  :size="'is-medium'"
                  :type="'is-success'"
                  :left-label='true'
                  @input="saveIgnoreDelayedState()">Ignorar estado con retraso</b-switch>
              </div>
              <p class="mb-2">
                <b-icon pack="fas" icon="info-circle"></b-icon>
                Arrastre u oculte los paneles para configurar como se visualizarán en la vista general de cada actividad.
              </p>
              <div class="flex flex-wrap justify-center">
                <div style="height: 650px" class="flex w-3/4 text-white">
                  <div style="background: #333" class="w-1/2 h-full m-1 flex justify-center items-center text-2xl">
                      <b>DIARIO DE LA ACTIVIDAD</b>
                  </div>
                  <div class="w-1/2 h-full m-1 text-xl">
                      <draggable
                        :list="list"
                        class="h-full"
                        ghost-class="ghost"
                        @start="dragging = true"
                        @end="dragging = false"
                        @change="saveActivityPanels()"
                      >
                        <div
                          class="pb-2 text-lg"
                          style="height: 14.2%"
                          v-for="element, index in list"
                          :key="element.name"
                        >
                          <div
                            :style="element.show ? 'background: #38c172': 'background: #d94a58'"
                            class="h-1/4 flex justify-center items-center cursor-pointer rounded-t-lg"
                            @click="saveActivityPanels(index)"
                          >
                            <b-icon pack="fa" size="is-small" :icon="element.show ? 'eye': 'eye-slash'"></b-icon>
                          </div>
                          <div class="h-3/4 bg-blue flex justify-center items-center cursor-move rounded-b-lg">
                            <b>{{$t(element.name)}}</b>
                          </div>
                        </div>
                      </draggable>
                  </div>
                </div>
              </div>
          </div>

        </div>
      </b-tab-item>

      <b-tab-item>
        <template slot="header">
          <span> Lista de actividades </span>
        </template>
        <div class="panel">
          <div v-if="isLoading" class="my-4 text-center">
            <scale-loader />
          </div>
          <div v-else >
              <div class="mb-4 flex flex-row flex-wrap items-center" style="gap: 16px;">
                <span class="font-semibold flex items-center" style="gap: 6px;">
                  <b-icon pack="fas" icon="eye"></b-icon>
                  {{ $t('initial_view_activities_label') }}
                </span>
                <b-radio v-model="initialViewActivities" native-value="activities" @input="saveInitialView()">
                  {{ $t('activities') }}
                </b-radio>
                <b-radio v-model="initialViewActivities" native-value="groups" @input="saveInitialView()">
                  {{ $t('activity_groups') }}
                </b-radio>
                <b-radio v-model="initialViewActivities" native-value="weekly" @input="saveInitialView()">
                  {{ $t('weekly_planning_view') }}
                </b-radio>
              </div>
              <hr class="mb-4">
              <!-- Columnas de la vista semanal -->
              <template v-if="initialViewActivities === 'weekly'">
                <p class="mb-2">
                  <b-icon pack="fas" icon="info-circle"></b-icon>
                  {{ $t('weekly_columns_config_info') }}
                </p>
                <template v-for="levelDef in weeklyColumnLevels">
                  <div v-for="column in levelDef.columns" :key="`${levelDef.level}-${column.key}`" class="mb-2">
                    <b-field>
                      <b-switch
                        v-model="weeklyColumns[levelDef.level][column.key].visible"
                        type="is-success"
                        @input="saveWeeklyColumns()"
                      >
                        {{ $t(column.labelKey) }} ({{ $t(levelDef.labelKey) }})
                      </b-switch>
                    </b-field>
                  </div>
                </template>
              </template>
              <template v-else>
                <p class="mb-2">
                  <b-icon pack="fas" icon="info-circle"></b-icon>
                  Configure que columnas estarán visibles en la lista de actividades.
                </p>
                <div v-for="(column, index) in columns" :key="index" class="mb-2">
                  <b-field v-if="index !== 'task_status' || (company && company.configs && company.configs.subtasks == true)">
                    <b-switch v-model="columns[index].visible" type="is-success" @input="saveColumns()">
                        {{$t(column.title)}}
                        <span v-if="columns_tooltips[index]" class="ml-4 text-xs text-gray-500">{{ $t(columns_tooltips[index]) }}</span>
                    </b-switch>
                  </b-field>
                </div>
              </template>
          </div>

        </div>
      </b-tab-item>
      <!-- Pestaña: Módulos -->
      <b-tab-item>
      <template slot="header">
        <span> Módulos </span>
      </template>
      <div class="panel">
        <p class="mb-2">
          <b-icon pack="fas" icon="info-circle"></b-icon>
          Configure qué módulos deben mostrarse en el menú lateral.
        </p>
        <div v-for="(mod, idx) in modules" :key="mod.key" class="mb-2">
          <b-field>
            <b-switch
              v-model="modules[idx].enabled"
              :disabled="mod.required"
              type="is-success"
              @input="saveModules"
            >
              {{ $t(mod.label) }}
            </b-switch>
          </b-field>
        </div>
      </div>
    </b-tab-item>
    </b-tabs>
  </div>
</div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from 'axios'
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import draggable from "vuedraggable";

/**
 * Columnas configurables de la vista semanal (configs.weekly_columns del proyecto).
 * Las keys coinciden con las columnas de activities-weekly-table.vue:
 * - activity: WEEKLY_TABLE_COLUMNS (tabla principal)
 * - subactivity: SUBACTIVITY_TABLE_COLUMNS (subtabla NIVEL 2)
 */
const WEEKLY_ACTIVITY_COLUMNS = [
  { key: 'code', labelKey: 'code' },
  { key: 'kks', labelKey: 'kks' },
  { key: 'group', labelKey: 'group' },
  { key: 'name', labelKey: 'name' },
  { key: 'predecessors', labelKey: 'predecessors' },
  { key: 'successors', labelKey: 'successors' },
  { key: 'baseline_line', labelKey: 'baseline' },
  { key: 'latest_planning', labelKey: 'latest_planning' },
  { key: 'progress', labelKey: 'progress' },
  { key: 'last_assignment_date', labelKey: 'last_assignment_update' },
  { key: 'p6_progress', labelKey: 'p6_progress' },
  { key: 'weight', labelKey: 'weight' },
  { key: 'physical_quantity', labelKey: 'weekly_col_physical_quantity' },
  { key: 'tracking_done', labelKey: 'weekly_col_tracking_done' },
  { key: 'tracking_pending', labelKey: 'weekly_col_tracking_pending' },
  { key: 'tracking_scheduled_hours', labelKey: 'weekly_col_scheduled_man_hours' },
  { key: 'tracking_done_hours', labelKey: 'weekly_col_done_man_hours' },
  { key: 'tracking_pending_hours', labelKey: 'weekly_col_pending_man_hours' },
  { key: 'supervisor', labelKey: 'supervisor' },
  { key: 'manager', labelKey: 'person_in_charge' },
  { key: 'people', labelKey: 'people' },
  { key: 'scheduled_start_date', labelKey: 'planned_start_date' },
  { key: 'scheduled_end_date', labelKey: 'planned_end_date' },
  { key: 'scheduled_duration_days', labelKey: 'weekly_col_planned_duration' },
  { key: 'planned_float', labelKey: 'weekly_col_planned_float' },
  { key: 'planned_progress', labelKey: 'weekly_col_planned_accumulated_progress' },
  { key: 'planned_kpi', labelKey: 'weekly_col_planned_kpi' },
  { key: 'current_start_date', labelKey: 'scheduled_start_date' },
  { key: 'current_end_date', labelKey: 'scheduled_end_date' },
  { key: 'current_duration_days', labelKey: 'weekly_col_scheduled_duration' },
  { key: 'scheduled_float', labelKey: 'weekly_col_scheduled_float' },
  { key: 'scheduled_progress', labelKey: 'weekly_col_scheduled_accumulated_progress' },
  { key: 'scheduled_kpi', labelKey: 'weekly_col_scheduled_kpi' },
  { key: 'real_start', labelKey: 'real_start_date' },
  { key: 'real_end', labelKey: 'real_end_date' },
  { key: 'real_duration_days', labelKey: 'weekly_col_real_duration' },
  { key: 'real_float', labelKey: 'weekly_col_real_float' },
  { key: 'real_kpi', labelKey: 'weekly_col_real_kpi' },
]

const WEEKLY_SUBACTIVITY_COLUMNS = [
  { key: 'code', labelKey: 'code' },
  { key: 'name', labelKey: 'name' },
  { key: 'weight', labelKey: 'weight' },
  { key: 'prev_week_progress', labelKey: 'prev_week_progress' },
  { key: 'weekly_progress', labelKey: 'weekly_progress' },
  { key: 'people', labelKey: 'people' },
  { key: 'scheduled_hours', labelKey: 'scheduled_hours' },
  { key: 'registered_hours', labelKey: 'registered_hours' },
  { key: 'current_start_date', labelKey: 'scheduled_start_date' },
  { key: 'current_end_date', labelKey: 'scheduled_end_date' },
  { key: 'supervisor', labelKey: 'supervisor' },
  { key: 'manager', labelKey: 'person_in_charge' },
]

const WEEKLY_COLUMN_LEVELS = [
  { level: 'activity', labelKey: 'activity', columns: WEEKLY_ACTIVITY_COLUMNS },
  { level: 'subactivity', labelKey: 'subactivity', columns: WEEKLY_SUBACTIVITY_COLUMNS },
]

/**
 * Normaliza configs.weekly_columns: todas las columnas presentes, visibles por defecto.
 * @returns {{ activity: Object<string, {visible: boolean}>, subactivity: Object<string, {visible: boolean}> }}
 */
function buildWeeklyColumnsConfig(saved = null) {
  const config = {}
  WEEKLY_COLUMN_LEVELS.forEach(({ level, columns }) => {
    const savedLevel = saved && saved[level] ? saved[level] : {}
    config[level] = {}
    columns.forEach(({ key }) => {
      const savedColumn = savedLevel[key]
      config[level][key] = {
        visible: savedColumn && typeof savedColumn.visible === 'boolean' ? savedColumn.visible : true,
      }
    })
  })
  return config
}


export default {
  middleware: 'auth',
  title: 'activity_edit_page_title',
  subtitle: 'activity_edit_page_subtitle',
  menuOption: '0-2',
  components: {
    ScaleLoader,
    draggable
  },
  data: () => ({
    projectId: null,
    entity: 'project',
    isLoading: false,
    mainActiveTab: 0,

    modules: [
      { key: 'activities',             label: 'activities_planning',     required: true,  enabled: true },
      { key: 'document_manager',       label: 'document_manager',        required: true,  enabled: true },
      // — configurables —
      { key: 'workflows',              label: 'validations',             required: false, enabled: true },
      { key: 'technical_specifications',label:'technical_specification', required: false, enabled: true },
      { key: 'boq',                    label: 'assignments',             required: false, enabled: true },
      { key: 'certifications',         label: 'certifications',          required: false, enabled: true },
      { key: 'documents',              label: 'documents',               required: false, enabled: true },
      { key: 'drawings',               label: 'drawings',                required: false, enabled: true },
      { key: 'issues',                 label: 'issues',                  required: false, enabled: true },
      { key: 'organization_chart',     label: 'org_chart',               required: false, enabled: true },
      { key: 'warehouse',              label: 'storehouse',              required: false, enabled: true },
      { key: 'bim_module',             label: 'bim_module',              required: false, enabled: true },
      { key: 'locations',              label: 'locations',               required: false, enabled: true },
      { key: 'permitting',             label: 'permitting',              required: false, enabled: true },
    ],

    list: [
      { name: "panel_progress", show: true },
      { name: "panel_subactivities", show: true },
      { name: "panel_measurements", show: true },
      { name: "panel_validations", show: true },
      { name: "panel_issues", show: true },
      { name: "panel_documents", show: true },
      { name: "panel_materials", show: true },
    ],

    columns: {
      'in_planning': { title: 'in_planning', visible: true },
      'user': { title: 'manager', visible: true },
      'planning_code': { title: 'code', visible: true },
      'name': { title: 'name', visible: true },
      'location': { title: 'location', visible: true },
      'type': { title: 'type', visible: true },
      'original_progress': { title: 'baseline', visible: true },
      'latest_progress': { title: 'latest_updated_planning', visible: true },
      'progress': { title: 'progress', visible: true },
      'actual_progress': { title: 'actual_progress', visible: true },
      'current_start_date': { title: 'start_date', visible: true },
      'current_end_date': { title: 'end_date', visible: true },
      'gantt_expected_start_date': { title: 'expected_start_date_gantt', visible: false },
      'gantt_expected_end_date': { title: 'expected_end_date_gantt', visible: false },
      'gantt_real_start_date': { title: 'actual_start', visible: true },
      'gantt_real_end_date': { title: 'actual_end', visible: true },
      'status': { title: 'status', visible: true },
      'actual_status': { title: 'actual_status', visible: true },
      'task_status': { title: 'task_status', visible: true },
      'status_id': { title: 'custom_status', visible: true },
      'notifications': { title: 'notifications', visible: true },
    },

    columns_tooltips: {
      'original_progress': 'column_visible_auditors',
      'latest_progress': 'column_visible_auditors',
      'actual_progress': 'column_visible_auditors',
      'actual_status': 'column_visible_auditors',
      'gantt_real_start_date': 'column_visible_auditors',
      'gantt_real_end_date': 'column_visible_auditors',
    },

    ignore_delayed_state: false,

    initialViewActivities: 'activities',

    // Columnas de la vista semanal (configs.weekly_columns), separadas por actividad / subactividad
    weeklyColumnLevels: WEEKLY_COLUMN_LEVELS,
    weeklyColumns: buildWeeklyColumnsConfig(),

    dragging: false
  }),


  created() {

    this.projectId = this.$route.params.project_id || null

    if( this.projectId )
    {
      this.$options.title = 'project_edit_page_title'
      this.$options.subtitle = [
        "project_page_subtitle",
        [this.navData.area_name.toUpperCase()]
      ];
    }

  },

  computed: {
    ...mapGetters({
      navData: "app/navData",
      visualConfig: "app/visualConfig",
      project: "app/project",
      company: "app/company",
    }),
  },

  mounted() {
    this.getVisualConfig()
  },


  methods: {

  async saveModules() {
      // Preparar payload
      const payload = {
        modules: this.modules.map(m => ({
          key:     m.key,
          enabled: m.enabled
        }))
      };
      // Guardar en el back
     const { data } = await axios.post(`/api/v2/project/${this.projectId}/configs`, payload);

      // Refrescar el project entero en Vuex para que el watcher ( Sidebar)
      
      if (data && data.success && data.project) {
        this.$buefy.toast.open({ message: this.$t('updated'), type: 'is-success', position: 'is-top-right' });
        this.$store.dispatch('app/setProject', { project: data.project });
      }
     
    },
    async getVisualConfig() {
      this.isLoading = true;
      let {data} = await axios.get("/api/v2/project/"+this.projectId+"/configs");
      if (data && data.success) {
        if (data.data?.activities_panels) {
          // mapeamos la configuración que tenian previamente
          let activitiesPanels = data.data.activities_panels

          let visiblePanels = activitiesPanels.map(p => this.list.find(l => p.name == l.name))

          // obtenemos los q no estaban en la configuracion y los agregamos
          let hiddenPanels = []
          for (let panel of this.list) {
            if (!visiblePanels.some(vPanel => vPanel.name == panel.name)) {
              panel.show = false
              hiddenPanels.push(panel)
            }
          }
          this.list = visiblePanels.concat(hiddenPanels)
        }
        if (data.data?.activities_columns) {
          for (let column in this.columns) {
            if (data.data.activities_columns[column]) {
              this.columns[column] = data.data.activities_columns[column]
            }
          }
        } else if (this.project.is_gantt_inspected == 1) {
          // Sin config guardada y is_gantt_inspected=1: ocultar columnas de "actual"
          const inspectedHiddenColumns = ['actual_progress', 'actual_status', 'gantt_real_start_date', 'gantt_real_end_date']
          inspectedHiddenColumns.forEach(col => {
            if (this.columns[col]) {
              this.columns[col].visible = false
            }
          })
        }

        if (data.data?.ignore_delayed_state) {
          this.ignore_delayed_state = data.data.ignore_delayed_state
        }
        if (data.data?.initial_view_activities) {
          this.initialViewActivities = data.data.initial_view_activities
        }
        this.weeklyColumns = buildWeeklyColumnsConfig(data.data?.weekly_columns)
        const savedModules = data.data?.modules;
        if (Array.isArray(savedModules) && savedModules.length > 0) {
          this.modules = this.modules.map(m => {
            const found = savedModules.find(x => x.key === m.key);
            return { ...m, enabled: found ? !!found.enabled : m.enabled };
          });
        } else {
          // no había módulos guardados se  activo todos
          this.modules = this.modules.map(m => ({ ...m, enabled: true }));
        }
      }
      this.isLoading = false;
    },

    async saveActivityPanels(index = null) {
      if (index || index == 0) {
        this.changeShow(index)
      }

      let data = {
        activities_panels: [],
        modules: this.modules.map(m => ({
          key:     m.key,
          enabled: m.enabled
        }))
      }

      for (let e of this.list) {
        if (e.show) {
          data.activities_panels.push({
            name: e.name
          })
        }
      }

      // Enviamos el form y recibimos el proyecto procesado
      const { data: response } = await axios.post("/api/v2/project/" + this.projectId + "/configs", data);

      // actualizamos en el storage si estamos en el mismo proyecto
      if (this.project.id == this.projectId) {
        this.$store.dispatch('app/setVisualConfig', { config: {activities_panels: data.activities_panels,  modules:data.modules} })
      }
      // Actualización global del proyecto procesado
      if (response && response.success && response.project) {
        this.$store.dispatch('app/setProject', { project: response.project });
      }
    },

    changeShow(index) {
      this.list[index].show = !this.list[index].show
    },

    async saveColumns() {
      let payload = {
        activities_columns: { ...this.columns }
      };

      // Enviamos el form y recibimos el proyecto procesado
      const { data } = await axios.post("/api/v2/project/" + this.projectId + "/configs", payload);
      // Actualizamos el proyecto completo en Vuex
      if (data && data.success && data.project) {
        this.$buefy.toast.open({ message: this.$t('updated'), type: 'is-success', position: 'is-top-right' });
        this.$store.dispatch('app/setProject', { project: data.project });
        this.$store.dispatch('app/setVisualConfig', { config: data.project.configs }); 
      }
    },

    /** PATCH fusiona la clave en configs sin pisar el resto (saveVisualConfig solo admite claves fijas). */
    async saveWeeklyColumns() {
      const weeklyColumns = JSON.parse(JSON.stringify(this.weeklyColumns))
      try {
        const { data } = await axios.patch("/api/v2/project/" + this.projectId + "/configs", {
          configs: { weekly_columns: weeklyColumns }
        });
        if (data && data.success) {
          this.$buefy.toast.open({ message: this.$t('updated'), type: 'is-success', position: 'is-top-right' });
          if (this.project && this.project.id == this.projectId && data.configs) {
            this.$store.dispatch('app/setProject', { project: { ...this.project, configs: data.configs } });
            this.$store.dispatch('app/setVisualConfig', { config: data.configs });
          }
        }
      } catch (error) {
        this.$notify.error('error_saving_data')
      }
    },

    async saveInitialView() {
      const { data } = await axios.post("/api/v2/project/" + this.projectId + "/configs", {
        initial_view_activities: this.initialViewActivities
      });
      if (data && data.success && data.project) {
        this.$buefy.toast.open({ message: this.$t('updated'), type: 'is-success', position: 'is-top-right' });
        this.$store.dispatch('app/setProject', { project: data.project });
        this.$store.dispatch('app/setVisualConfig', { config: data.project.configs });
      }
    },

    async saveIgnoreDelayedState() {
      let data = {
        ignore_delayed_state: this.ignore_delayed_state
      }

      // Enviamos el form
      await axios.post("/api/v2/project/"+this.projectId+"/configs", data);

      // actualizamos en el storage si estamos en el mismo proyecto
      if (this.project.id == this.projectId) {
        this.$store.dispatch('app/setVisualConfig', { config: {ignore_delayed_state: data.ignore_delayed_state} })
      }
    },

    goToPage(destiny) {

      switch (destiny) {

        case 'edit-project':
            this.$router.push({ name: 'project.edit', params: {
              project_id: this.projectId
            } })
            break;
      }

    },

  },
};
</script>
<style scoped>
.ghost {
  opacity: 0.8;
}
</style>
